export const formatLabelsWithPercentage = (labels, values, labelTexts) => {
  if (labels.length < 1 || values.length < 1) return [];

  const sum = values.reduce((prev, curr) => prev + curr);
  return labels.map((event, i) => ({
    label: `${labelTexts ? labelTexts[event] : event} (${((values[i] / sum) * 100).toFixed(1)}%)`,
    name: event,
  }));
};
